import { AbstractControl } from '@angular/forms';
import { isDate } from '../../utils/helpers';
declare const moment: any;


export const CustomValidateDate = (control: AbstractControl): {[key: string]: any} => {

  if (!control.value) {
    return null;
  }
  if (!isDate(control.value)) {
    return {
      invalidDate: true,
      message: 'It is not a valid date'
    };
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/date/date.validator.ts